export function changSizeBotIconAction (sizeBotIcon) {
	return {
		type: 'CHANGE_SIZE_BOT_ICON',
		payload: sizeBotIcon
	}
}